
// Importación de React (necesario para JSX)
import React from 'react';
// Importación del archivo de estilos CSS modules
import styles from './Services.module.css';

// Componente funcional Services
const Services = () => {
  return (
    // Contenedor principal con ID para navegación y clase CSS
    <div id="Services" className={styles.services}>
      {/* Contenedor interno para centrar el contenido */}
      <div className={styles.serviceContainer}>
        
        {/* Contenedor para imagen y texto superpuesto */}
        <div className={styles.imageWrapper}>
          {/* Imagen principal de servicios - ocupa todo el ancho */}
          <img 
            src={`${process.env.PUBLIC_URL}/Services2.jpg`}
            alt="Services2 QS - Servicios de transporte y logística"
            className={styles.serviceImage}
            loading="lazy" // Carga diferida para mejor rendimiento
          />

          {/* Texto superpuesto - Ahora estará posicionado sobre la imagen */}
          <div className={styles.textOverlay}>
              <h1 className={styles.heroTitle}>Servicios</h1>
          </div>
        </div>
        
        {/* Wrapper para centrar solo el contenido */}
        <div className={styles.servicesContentWrapper}>
          {/* Contenedor en grid para los servicios */}
          <div className={styles.servicesContent}>

            <h2>Transportes</h2>

            {/* Servicio 1: Transporte Terrestre FTL */}
            <div className={styles.serviceItem}>
              <h3>Transporte Terrestre Dedicado</h3>
              <p>
                Servicio de Torton, Rabón, Cajas de 53', Unidades 3.5 y 1 Tonelada 
                por las aduanas de Veracruz, Manzanillo y áreas metropolitanas del 
                país, así como CDMX, Toluca, Querétaro y Monterrey.
              </p>
            </div>

            {/* Servicio 2: Puerta a Puerta */}
            <div className={styles.serviceItem}>
              <h3>Servicio Puerta a Puerta</h3>
              <p>
                Servicio puerta-puerta por distintos estados de la república y países 
                como Estados Unidos y Canadá.
              </p>
            </div>

            {/* Servicio 3: Contenedores */}
            <div className={styles.serviceItem}>
              <h3>Contenedores de 20 DC // 40 HQ // Full // Isotanques</h3>
              <p>
                Servicios desde y hacia los puertos de Lázaro Cárdenas, Manzanillo, 
                Altamira y Veracruz.
              </p>
            </div>

            {/* Servicio 4: Carga Consolidada */}
            <div className={styles.serviceItem}>
              <h3>Carga Consolidada</h3>
              <p>
                Servicio de transporte de carga consolidada para cajas y pallets.
              </p>
            </div>

            {/* Servicio 5: Carga Peligrosa */}
            <div className={styles.serviceItem}>
              <h3>Carga Peligrosa</h3>
              <p>
                Traslado terrestre de mercancía peligrosa con manipulación  
                adecuada y considerando las medidas de seguridad pertinentes.
              </p>
            </div>

            {/* Servicio 6: Carga Sobredimensionada */}
            <div className={styles.serviceItem}>
              <h3>Carga Sobredimensionada</h3>
              <p>
                Servicio de carga sobredimensionada con equipos especializados 
                y permisos necesarios para transportes de gran tamaño.
              </p>
            </div>

            {/* Servicio 7: Carga Refrigerada */}
            <div className={styles.serviceItem}>
              <h3>Carga Refrigerada</h3>
              <p>
                Transporte especializado en carga refrigerada y perecedera, por 
                Manzanillo con altos estándares de calidad y cuidado para recibir la 
                mercancía en óptimas condiciones.
              </p>
            </div>

            {/* TÍTULO DIVISOR "OTROS" - Mismo nivel que h2 */}
            <h2 className={styles.otrosTitle}>Otros Servicios</h2>

            {/* Servicio 1: ALMACÉN ESTRATÉGICO*/}
            <div className={styles.serviceItem}>
              <h3>Almacén Estratégico</h3>
              <p>
                Dentro de nuestros servicios, ofrecemos la facilidad de 
                almacenes estratégicos para resguardar contenedores de 20 DC, 
                40 HQ, Isotanques, mercancías peligrosas etc.
              </p>
            </div>

            {/* Servicio 2: Seguro de Mercancía */}
            <div className={styles.serviceItem}>
              <h3>Seguro de Mercancía</h3>
              <p>
                Actualmente existen numerosos riesgos que forman parte del 
                traslado terrestre; las condiciones de carretera, clima e 
                inseguridad, son cosas que están fuera de nuestro control y es 
                por ello que nuestra amplia recomendación es siempre estar 
                protegidos por un seguro de mercancía, el cual podemos hacer y 
                gestionar para ustedes como clientes y garantizar una plena 
                tranquilidad al momento de cualquier traslado. 
              </p>
            </div>

            {/* Servicio 3: Seguro de Contenedores */}
            <div className={styles.serviceItem}>
              <h3>Seguro de Contenedores</h3>
              <p>
                Los costos por daños a los contenedores en ocasiones suelen ser 
                cantidades exorbitantes y con procesos complejos con las 
                navieras, nosotros podemos gestionar el seguro de 
                contenedores para salvaguardar cualquier contratiempo o 
                daño que pueda llegar a sufrir mientras se tiene en uso bajo 
                la responsabilidad de nuestros clientes.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

// Exportación por defecto del componente
export default Services;